export type ShortcutHandler = {
	requireAltKey?: boolean
	requireCtrlKey?: boolean
	requireMetaKey?: boolean
	requireShiftKey?: boolean
	keys: string[]
	handler: (e: Event) => void
}

export function makeShortcutListener(
	element: EventTarget, // Document | Window | Element
	handlers: ShortcutHandler[],
) {
	const keyRefCollection: string[] = []

	const handleKeyDown = (e: KeyboardEvent) => {
		if (keyRefCollection.find((v) => v === e.key) !== undefined) return
		keyRefCollection.push(e.key)

		for (const handler of handlers) {
			if (matchHandler(keyRefCollection, handler, e)) {
				handler.handler(e)
				e.stopPropagation()
				e.preventDefault()
			}
		}
	}

	const handleKeyUp = (e: KeyboardEvent) => {
		const keyRefCollectionIndex = keyRefCollection.indexOf(e.key)
		if (keyRefCollectionIndex === -1) return

		keyRefCollection.splice(keyRefCollection.indexOf(e.key), 1)
	}

	const handleElementFocusLost = (e: FocusEvent) => {
		keyRefCollection.length = 0
	}

	element.addEventListener('keydown', handleKeyDown as never, {
		capture: true,
	})
	element.addEventListener('keyup', handleKeyUp as never, {
		capture: true,
	})

	element.addEventListener('blur', handleElementFocusLost as never, {
		capture: true,
	})

	return () => {
		element.removeEventListener('keydown', handleKeyDown as never, {
			capture: true,
		})
		element.removeEventListener('keyup', handleKeyUp as never, {
			capture: true,
		})
		element.removeEventListener('blur', handleElementFocusLost as never, {
			capture: true,
		})
	}
}

function matchHandler(
	currentKeysDown: string[],
	handler: ShortcutHandler,
	e: KeyboardEvent,
): boolean {
	const operationKeysMet =
		(handler.requireAltKey ?? false) == e.altKey &&
		(handler.requireCtrlKey ?? false) == e.ctrlKey &&
		(handler.requireMetaKey ?? false) == e.metaKey &&
		(handler.requireShiftKey ?? false) == e.shiftKey

	for (const handlerKey of handler.keys) {
		let found = false
		for (const key of currentKeysDown) if (key == handlerKey) found = true
		if (found == false) return false
	}

	return operationKeysMet
}
